import { confirmAlert } from "react-confirm-alert";
import { Button } from "tabler-react";

// Function to inject CSS to style the react-confirm-alert container
const injectCustomStyles = () => {
    // Remove any existing styles to avoid duplication
    const existingStyle = document.getElementById("confirm-reminder-styles");
    if (existingStyle) {
        existingStyle.remove();
    }

    // Create style element
    const style = document.createElement("style");
    style.id = "confirm-reminder-styles";
    style.innerHTML = `
    .react-confirm-alert {
      width: 40% !important;
      max-width: 60% !important;
      margin: 0 auto !important;
    }

    .react-confirm-alert > div {
      width: 100% !important;
      max-width: 100% !important;
    }

    .react-confirm-alert-body {
      width: 100% !important;
      max-width: 100% !important;
    }

    .react-confirm-alert-overlay {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }

    .invoice-reminder-summary {
      background-color: #f8f9fa;
      border-radius: 3px;
      padding: 15px;
      margin-bottom: 15px;
    }

    .invoice-reminder-summary .info-label {
      font-weight: bold;
      margin-right: 5px;
    }

    .invoice-reminder-summary .text-danger {
      color: #cd201f;
    }
  `;

    // Add to document head
    document.head.appendChild(style);
};

// Separate component for the dialog content to properly use hooks
const ReminderDialog = ({ t, invoice, onConfirm, onClose }) => {
    return (
        <div className="custom-ui">
            <h1>{t("finance.invoices.send_reminder")}</h1>

            <div className="invoice-reminder-summary">
                <div>
                    <span className="info-label">{t("general.account")}:</span>{" "}
                    {invoice.account?.fullName}
                </div>
                <div>
                    <span className="info-label">
                        {t("finance.invoices.invoice_number")}:
                    </span>{" "}
                    {invoice.invoiceNumber}
                </div>
                <div>
                    <span className="info-label">
                        {t("finance.invoices.days_overdue")}:
                    </span>{" "}
                    <span className="text-danger">
                        {invoice.daysOverdue || 0}
                    </span>
                </div>
                <div>
                    <span className="info-label">{t("general.balance")}:</span>{" "}
                    <span className="text-danger">
                        {invoice.balanceDisplay}
                    </span>
                </div>
            </div>
            <Button className="pull-right" color="secondary" onClick={onClose}>
                {t("general.cancel")}
            </Button>
            <Button
                className="pull-right mr-2"
                color="primary"
                onClick={() => {
                    onConfirm(invoice);
                    onClose();
                }}
            >
                {t("general.send")}
            </Button>
        </div>
    );
};

const confirm_reminder = ({ t, invoice, onConfirm }) => {
    // Inject custom styles before showing the dialog
    injectCustomStyles();

    confirmAlert({
        customUI: ({ onClose }) => (
            <ReminderDialog
                t={t}
                invoice={invoice}
                onConfirm={onConfirm}
                onClose={onClose}
            />
        ),
    });
};

export default confirm_reminder;
